import { isMobileAtom, useRecoil } from '@orcar/common-d2c';
import styled from 'styled-components';
import { loadingAnimation } from '@/styles/animation';

const SkeletonReservationDetail = () => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  return (
    <ContentWrapper isMobile={isMobile}>
      <Center>
        <SkeletonBar width={80} height={33} />
        <SkeletonBar width={360} height={20} />
        <SkeletonBar width={200} height={120} />
      </Center>

      <SkeletonBar width={260} height={24} marginBottom={8} />
      <SkeletonBar width={172} height={19} marginBottom={16} />
      <SkeletonBar width={200} height={19} marginBottom={30} />
      <SkeletonBar width={320} height={19} marginBottom={12} />
      <SkeletonBar width={120} height={19} marginBottom={0} />
    </ContentWrapper>
  );
};

export default SkeletonReservationDetail;

const ContentWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  width: 792px;
  padding: ${({ isMobile }) =>
    isMobile ? '30px 20px 40px 20px' : '60px 55px'};
  background-color: ${({ theme }) => theme.COLOR.WHITE};
  border: 1px solid ${({ theme }) => theme.COLOR.GREY_05};
  border-radius: 10px;
  box-shadow: ${({ isMobile }) =>
    isMobile && '0px 3px 10px rgba(0, 0, 0, 0.13)'};
`;

const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 60px;
`;

const SkeletonBar = styled.div<{
  width: number;
  height: number;
  marginBottom?: number;
}>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  margin-bottom: ${({ marginBottom }) => `${marginBottom}px` || '0px'};
  background: ${({ theme }) =>
    `linear-gradient(90deg, ${theme.COLOR.GREY_03}, #f5f5f5, ${theme.COLOR.GREY_03})`};
  background-size: 200% 100%;
  animation: ${loadingAnimation} 1.5s infinite;
`;

const BottomWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
